import Globals from "@/components/globals";
import Axios from "axios";
import cacheService from "@/services/cache";
import { user } from "@/store/user/user";
import { store } from "@/store/store";

const axios = Axios.create({
    baseURL: Globals.getBackHost()
});

// A middleware that is executed for every response, see https://github.com/axios/axios#interceptors
axios.interceptors.response.use(
    function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    async function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        // The user is not authenticated (anymore) -> redirect to login
        if (error.response.status === 401) {
            await redirectToLogin();
            // Http code 428 is used by the backend when the user needs to accept the new CGU version
        } else if (error.response.status === 428) {
            store.dispatch("cguStore/setCguStatus", false);
            store.dispatch("cguStore/setShown", true);
            return Promise.reject(error);
            // Http code 422 is used by the backend when a validation error occurred
        } else if (error.response.status === 422) {
            error.displayMessage = error.response.data.join(line => line + ";");
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

function getToken() {
    const oUser = cacheService.getRem3rchUser();
    return oUser && oUser.token;
}

function getHeader(isFile = false) {
    if (isFile) {
        return {
            Authorization: getToken()
        };
    }
    return {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: getToken()
    };
}

export default {
    async get(url, options) {
        console.assert(typeof url === "string");
        options = options || {};
        const res = await axios.get(url, { ...options, headers: getHeader() });
        return res.data;
    },
    async post(url, data, options = {}, isFile = false) {
        console.assert(typeof url === "string");
        const res = await axios.post(url, data, { ...options, headers: getHeader(isFile) });
        return res.data ? res.data : res;
    },
    async put(url, data, isFile = false) {
        console.assert(typeof url === "string");
        const res = await axios.put(url, data, { headers: getHeader(isFile) });
        return res.data;
    },
    async patch(url, data, isFile = false) {
        console.assert(typeof url === "string");
        const res = await axios.patch(url, data, { headers: getHeader(isFile) });
        return res.data;
    },
    async delete(url) {
        console.assert(typeof url === "string");
        const res = await axios.delete(url, { headers: getHeader() });
        return res.data;
    }
};

export async function redirectToLogin() {
    if (!window.location.pathname.match("^/login")) {
        // Si l'utilisateur n'est pas en train de se faire déconnecter...
        // Permet d'éviter que x requêtes fassent pop x modales d'alerte
        // Seule la 1re sera affichée
        if (!user.state.disconnectingUser) {
            // le watcher sur cette var ce trouve dans App.vue, section watch
            //Vaut initialement false
            // la passer à true fait apparaitre une modale alertant l'utilisateur qu'il va se faire déconnecter
            user.state.disconnectingUser = true;

            // window.location = "/login?redirect=token";
        }
    } else {
        throw new Error("Can't redirect to login page");
    }
    // return a promise with a long timeout to make sure subsequent operations are suspended until the redirect is finished
    // return new Promise(resolve => setTimeout(resolve, 10000));
}

export function redirectToLoginPage() {
    window.location = "/login?redirect=token";
}



// WEBPACK FOOTER //
// ./src/services/http.js